import { useState } from "react";
import { useParams } from "react-router";
import { useI18n } from "~/i18n";
import { resolveIpAssets } from "~/theme/resolve-theme";

export function Footer() {
  const { t, locale } = useI18n();
  const { slug = "" } = useParams<{ slug: string }>();
  const assets = resolveIpAssets(slug);
  const [bizInfoOpen, setBizInfoOpen] = useState(false);

  const logoSrc = assets.logos[locale as keyof typeof assets.logos] ?? assets.logos.ko;
  const logoAlt = assets.logoAlt[locale as keyof typeof assets.logoAlt] ?? assets.logoAlt.ko;

  const mutedColor = "var(--ip-text-muted)";

  return (
    <footer id="footer" className="footer relative z-[2] bg-white">
      <div className="footer__bottom py-10 max-md:py-8 px-6">
        <div className="mx-auto max-w-[1100px] flex flex-col items-center gap-4">
          <img src={logoSrc} alt={logoAlt} className="footer__logo-img h-9 w-auto opacity-75" />
          <div className="flex flex-col items-center">
            <button
              className="flex items-center gap-1 text-[11px] font-normal tracking-[0.05em] transition-colors"
              style={{ color: mutedColor }}
              onClick={() => setBizInfoOpen((v) => !v)}
            >
              (주)라프텔 사업자 정보
              <svg
                viewBox="0 0 12 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className={`w-3 h-3 transition-transform duration-200 ${bizInfoOpen ? "rotate-180" : ""}`}
              >
                <path d="M3 4.5L6 7.5L9 4.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <div
              className="overflow-hidden transition-all duration-300 ease-out"
              style={{
                maxHeight: bizInfoOpen ? "200px" : "0px",
                opacity: bizInfoOpen ? 1 : 0,
              }}
            >
              <div
                className="pt-2 text-center text-[11px] font-normal tracking-[0.05em] leading-[1.8]"
                style={{ color: mutedColor }}
              >
                <p>상호 : 주식회사 라프텔 / 대표 : 박종원</p>
                <p>
                  주소 : 서울특별시 영등포구 국제금융로 10, 13층 라프텔(여의도동, 서울국제 금융센터
                  투아이에프씨)
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-1.5">
            <div className="footer__links flex items-center gap-3">
              <a
                href="/"
                className="footer__link text-[11px] font-normal tracking-[0.05em] transition-colors"
                style={{ color: mutedColor }}
              >
                {t.footer.originals}
              </a>
              <span
                className="footer__sep text-[12px] leading-[1.7]"
                style={{ color: mutedColor, opacity: 0.4 }}
              >
                |
              </span>
              <a
                href="mailto:contact@laftel.net"
                className="footer__link text-[11px] font-normal tracking-[0.05em] transition-colors"
                style={{ color: mutedColor }}
              >
                {t.footer.contact}
              </a>
            </div>
            <p
              className="footer__copyright text-[11px] tracking-[0.05em] font-normal"
              style={{ color: mutedColor, opacity: 0.5 }}
            >
              {slug === "oneroomta"
                ? locale === "en" || locale === "ja"
                  ? "©Jibung ©Laftel inc."
                  : "©지붕 ©Laftel inc."
                : "© Lily & LEZHIN Ent. / Laftel inc. & KidariStudio, Inc."}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
